import styled from 'styled-components'
import AddCaptionComponent from './add-caption'
import CaptionComponent from './caption'
import TextStyleComponent from './text-styler'

export const Captions = styled.div`
    padding: 20px;
`

export const Caption = styled(CaptionComponent)`
    margin-bottom: 15px;
`

export const TextStyler = styled(TextStyleComponent)`
    margin-bottom: 15px;
`

export const AddCaption = styled(AddCaptionComponent)`
    ${TextStyler} {
        margin-top: 15px;
    }
`
